"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastNotification = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../../styles/palette");
var _enums = require("../../../enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var darkGrey = _palette.toastNotificationsColors.darkGrey,
  red = _palette.toastNotificationsColors.red;
var white = _palette.commonPalette.white;
var SUCCESS = _enums.TOAST_NOTIFICATIONS_TYPES.SUCCESS;
var ToastNotification = exports.ToastNotification = _styledComponents["default"].div.withConfig({
  displayName: "styles__ToastNotification",
  componentId: "sc-1w1xjuv-0"
})(["padding:15px;background-color:", ";cursor:pointer;margin:10px 20px;color:", ";border-radius:5px;font-size:14px;min-width:200px;box-shadow:0 2px 4px rgba(0,0,0,0.25);"], function (_ref) {
  var type = _ref.type;
  return type === SUCCESS ? darkGrey : red;
}, white);
//# sourceMappingURL=styles.js.map